import projectDocumentsComponent from './project-documents.component';

const projectDocumentsModule = angular.module('projectDocuments', [
])
  .component('projectDocuments', projectDocumentsComponent)
  .name;

export default projectDocumentsModule;
